module.exports = __webpack_public_path__ + "media/scholarship_winners/christine-b-e3a465e6.png";